import ContactTreuhaenderModal from "./ContactTreuhaenderModal";

export default ContactTreuhaenderModal;
